/**
 * Languages offered by the native-auth screens' switcher, with their flags.
 *
 * The native screens share the app-wide react-intl system (see i18nProvider):
 * the current language comes from Metronic's `useLang()` and switching goes
 * through Metronic's `setLanguage()`. This list only supplies the display
 * name + flag per locale, in display order.
 */
import {toAbsoluteUrl} from '../../../../_metronic/helpers';

export type NativeLang = 'fr' | 'en' | 'de' | 'es' | 'it';

export const LANGUAGES: {lang: NativeLang; name: string; flag: string}[] = [
  {lang: 'fr', name: 'Français', flag: toAbsoluteUrl('/media/flags/france.svg')},
  {lang: 'it', name: 'Italiano', flag: toAbsoluteUrl('/media/flags/italy.svg')},
  {lang: 'en', name: 'English', flag: toAbsoluteUrl('/media/flags/united-kingdom.svg')},
  {lang: 'de', name: 'Deutsch', flag: toAbsoluteUrl('/media/flags/germany.svg')},
  {lang: 'es', name: 'Español', flag: toAbsoluteUrl('/media/flags/spain.svg')},
];

export const getLanguageMeta = (lang: string): {name: string; flag: string} =>
  LANGUAGES.find((l) => l.lang === lang) ?? LANGUAGES[0];
